import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// Phone rendu à taille naturelle (307px) puis réduit → texte net
const SCALE = 0.55;
const NATURAL_W = 307;
const NATURAL_CLIP_H = 210; // on coupe juste sous la bulle

function PhoneMini() {
  const { t } = useTranslation();

  return (
    <Box sx={{
      width: Math.round(NATURAL_W * SCALE),
      height: Math.round(NATURAL_CLIP_H * SCALE),
      overflow: "hidden",
      flexShrink: 0,
    }}>
      <Box sx={{ width: NATURAL_W, position: "relative", transform: `scale(${SCALE})`, transformOrigin: "top left" }}>

        {/* Écran intérieur */}
        <Box sx={{ position: "absolute", left: 13, top: 18, width: 280, height: 606, overflow: "hidden", zIndex: 0 }}>
          <Box component="img" src="/assets/sms/phone_intern.png" alt="" sx={{ width: "100%", height: "auto" }} />
        </Box>

        {/* Masque barre de statut */}
        <Box sx={{ position: "absolute", bgcolor: "#f5f5f5", left: 22, top: 11, width: 255, height: 11, zIndex: 1 }} />

        {/* Masque blanc sous les infos contact */}
        <Box sx={{ position: "absolute", bgcolor: "white", left: 13, top: 132, width: 215, height: 78, zIndex: 1 }} />

        {/* Frame du téléphone */}
        <Box component="img" src="/assets/sms/tel.png" alt="" sx={{ position: "relative", width: NATURAL_W, zIndex: 2 }} />

        {/* Nom du commerce */}
        <Box sx={{ position: "absolute", top: 87, left: "50%", transform: "translateX(-50%)", zIndex: 3 }}>
          <Box sx={{ position: "relative" }}>
            <Box sx={{ position: "absolute", bgcolor: "#f5f5f5", height: 8, top: 1, left: 0, right: 0 }} />
            <Typography sx={{ position: "relative", fontFamily: "Poppins, sans-serif", fontSize: 8, lineHeight: 1.4, color: "#000", textAlign: "center", whiteSpace: "nowrap" }}>
              VOTRE COMMERCE
            </Typography>
          </Box>
        </Box>

        {/* Bulle SMS */}
        <Box sx={{ position: "absolute", left: 20, top: 133, width: 245, zIndex: 4 }}>
          <Box sx={{ bgcolor: "#e9e9eb", borderRadius: "10px", px: "12px", py: "6px", position: "relative" }}>
            <Box component="img" src="/assets/sms/triangle_bulle.png" alt="" sx={{ position: "absolute", left: -2, top: 30, width: 15, height: 14 }} />
            <Typography sx={{ fontFamily: "Poppins, sans-serif", fontSize: 10, lineHeight: 1.3, color: "#000" }}>
              {t("comingSoon.missedCalls.preview.smsMessagePrefix", "Hello, sorry we missed your call. Find us here 👉 ")}
              <Box component="span" sx={{ color: "#007aff", textDecoration: "underline" }}>votrecommerce.fr</Box>
              {t("comingSoon.missedCalls.preview.smsMessageSuffix", " See you soon, PizzaTime! Stop ")}
              <Box component="span" sx={{ color: "#007aff", textDecoration: "underline" }}>36180</Box>
            </Typography>
          </Box>
        </Box>

      </Box>
    </Box>
  );
}

function StatCard({ number, label, bgColor, textColor }: { number: string; label: string; bgColor: string; textColor: string }) {
  return (
    <Box sx={{ bgcolor: bgColor, borderRadius: "4px", p: "7px", width: 55, height: 55, boxSizing: "border-box" }}>
      <Typography fontWeight={700} fontSize={20} lineHeight={1.15} color={textColor}>{number}</Typography>
      <Typography fontWeight={500} fontSize={6} lineHeight={1.2} color="#000" mt="4px">{label}</Typography>
    </Box>
  );
}

export default function MissedCallsContent() {
  const { t } = useTranslation();

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" gap="14px" px={2} mt={2}>
      <PhoneMini />
      <Box sx={{ flexShrink: 0, bgcolor: "white", border: "4px solid #f2e3ff", borderRadius: "8px", p: "6px" }}>
        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px" }}>
          <StatCard number="124" label={t("comingSoon.missedCalls.preview.stats.missedCalls", "Missed calls")} bgColor="#DBEAFE" textColor="#70A3E6" />
          <StatCard number="118" label={t("comingSoon.missedCalls.preview.stats.smsSentAuto", "SMS sent automatically")} bgColor="#FFECEF" textColor="#FF9DAC" />
          <StatCard number="88" label={t("comingSoon.missedCalls.preview.stats.clicks", "Clicks on your links")} bgColor="#DCFCE7" textColor="#51A96F" />
          <StatCard number="59" label={t("comingSoon.missedCalls.preview.stats.recoveredCustomers", "Recovered customers")} bgColor="#F2E3FF" textColor="#CD93FF" />
        </Box>
      </Box>
    </Stack>
  );
}
